import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { useMediaQuery } from 'react-responsive';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import CommunityActions from '~/actions/community';

const CommunitySlider = ({ data, title, adsList = [], className }) => {
    const dispatch = useDispatch();
    const [current, setCurrent] = useState(0);

    const [adsIdx, setAdsIdx] = useState(Math.round(Math.random() * adsList.length));
    const [featured, setFeatured] = useState([]);
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

    useEffect(() => {
        const idx = Math.round(Math.random() * adsList.length);
        const adsData = adsList[idx];
        setAdsIdx(idx);
        setFeatured(adsData ? [...data, adsData] : data);
    }, [adsList.length]);

    useEffect(() => {
        const adsData = adsList[adsIdx];
        setFeatured(adsData ? [...data, adsData] : data);
    }, [data]);

    const settings = {
        infinite: true,
        slidesToShow: isMobile ? 1 : 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        vertical: !isMobile,
        pauseOnHover: false,
        beforeChange: (before, next) => setCurrent(next),
    };

    let slider;
    const handleClick = (e) => {
        setCurrent(e);
        slider.slickGoTo(e);
    };

    const handleOpenURL = (url) => {
        dispatch(CommunityActions.featuredpostsRequest(url.replace('/in/', '/')));
    };

    return (
        <div className={`c-cs d-flex ssm-column ${className}`}>
            <div className="card d-flex-3 me-2">
                <div className="d-flex jc-between mb-3">
                    <span className="dsl-b22 bold">{title || featured[current]?.title || featured[current]?.data?.title || featured[current]?.data?.synopsis}</span>
                    <div className="d-flex">
                        {featured.map((item, index) => (
                            <Icon key={index} name="fas fa-circle ms-1" color={current === index ? '#6899d7' : '#e5eef8'} size={14} onClick={() => handleClick(index)} />
                        ))}
                    </div>
                </div>
                <div className="d-none d-sm-block">
                    {current === data.length && featured[current] ? (
                        <div onClick={() => handleOpenURL(featured[current].url__target)}>
                            <Thumbnail className="mb-3" source={featured[current].img_xlarge} size="responsive" />
                            {title && (
                                <>
                                    <p className="dsl-b16 bold">{featured[current]?.title}</p>
                                    <p className="dsl-b16 truncate-one mb-0">{featured[current]?.description}</p>
                                </>
                            )}
                        </div>
                    ) : (
                        <div onClick={() => handleOpenURL(featured[current]?.data?.url)}>
                            <Thumbnail className="mb-3" source={featured[current]?.data?.image} size="responsive" />
                            {title && (
                                <>
                                    <p className="dsl-b16 bold">{featured[current]?.title}</p>
                                    <p className="dsl-b16 truncate-one mb-0">{featured[current]?.description}</p>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="d-flex-1 ms-2 c-cs-slick">
                <Slider ref={(e) => (slider = e)} {...settings}>
                    {featured.map((item, index) => (
                        <div className="img" key={`i${index}`}>
                            {data && (
                                <Thumbnail
                                    source={featured[index]?.img_small__300 || featured[index]?.data?.image}
                                    size="responsive"
                                    onClick={() => handleOpenURL(featured[index]?.url__target || featured[index]?.data?.url)}
                                />
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

CommunitySlider.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    adsList: PropTypes.array,
};

export default CommunitySlider;
